export interface Match {
  id: string
  jobId: string
  jobTitle: string
  company: string
  matchedAt: Date
  lastMessage?: string
  lastMessageAt?: Date
  unreadCount: number
  isRevealed: boolean
}

export const mockMatches: Match[] = [
  {
    id: 'm1',
    jobId: '1',
    jobTitle: 'Senior Frontend Utvikler',
    company: 'TechNorge AS',
    matchedAt: new Date(Date.now() - 2 * 60 * 60 * 1000), // 2 timer siden
    lastMessage: 'Hei! Vi setter pris på din interesse. Når passer det for en uformell chat?',
    lastMessageAt: new Date(Date.now() - 30 * 60 * 1000), // 30 min siden
    unreadCount: 2,
    isRevealed: false
  },
  {
    id: 'm2',
    jobId: '3',
    jobTitle: 'DevOps Engineer',
    company: 'CloudSolutions Norge',
    matchedAt: new Date(Date.now() - 24 * 60 * 60 * 1000), // 1 dag siden
    lastMessage: 'Flott! Kan du fortelle litt om din erfaring med Kubernetes?',
    lastMessageAt: new Date(Date.now() - 3 * 60 * 60 * 1000), // 3 timer siden
    unreadCount: 0,
    isRevealed: false
  },
  {
    id: 'm3',
    jobId: '6',
    jobTitle: 'React Native Utvikler',
    company: 'Mobile First',
    matchedAt: new Date(Date.now() - 48 * 60 * 60 * 1000), // 2 dager siden
    lastMessage: 'Takk for svar! Vi ser frem til å lære deg bedre å kjenne.',
    lastMessageAt: new Date(Date.now() - 24 * 60 * 60 * 1000), // 1 dag siden
    unreadCount: 1,
    isRevealed: false
  },
  {
    id: 'm4',
    jobId: '4',
    jobTitle: 'Fullstack Utvikler',
    company: 'Startup Hub Oslo',
    matchedAt: new Date(Date.now() - 4 * 60 * 60 * 1000), // 4 timer siden
    lastMessage: 'Vi liker profilen din! Har du erfaring med Next.js?',
    lastMessageAt: new Date(Date.now() - 1 * 60 * 60 * 1000), // 1 time siden
    unreadCount: 1,
    isRevealed: false
  },
  {
    id: 'm5',
    jobId: '5',
    jobTitle: 'Backend Developer',
    company: 'FinTech Norge',
    matchedAt: new Date(Date.now() - 6 * 60 * 60 * 1000), // 6 timer siden
    lastMessage: 'Hei! Vi ser du har solid erfaring med Node.js. Spennende!',
    lastMessageAt: new Date(Date.now() - 2 * 60 * 60 * 1000), // 2 timer siden
    unreadCount: 3,
    isRevealed: true
  },
  {
    id: 'm6',
    jobId: '7',
    jobTitle: 'UI/UX Designer',
    company: 'Design Studio Bergen',
    matchedAt: new Date(Date.now() - 72 * 60 * 60 * 1000), // 3 dager siden
    lastMessage: 'Portfolioen din er imponerende! Kan vi ta en prat?',
    lastMessageAt: new Date(Date.now() - 12 * 60 * 60 * 1000), // 12 timer siden
    unreadCount: 0,
    isRevealed: true
  },
  {
    id: 'm7',
    jobId: '8',
    jobTitle: 'Tech Lead',
    company: 'Enterprise Solutions AS',
    matchedAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000), // 5 dager siden
    lastMessage: 'Takk for en fin samtale! Vi kommer tilbake med tilbud snart.',
    lastMessageAt: new Date(Date.now() - 6 * 60 * 60 * 1000), // 6 timer siden
    unreadCount: 1,
    isRevealed: true
  },
  {
    id: 'm8',
    jobId: '9',
    jobTitle: 'Data Engineer',
    company: 'AI Innovators',
    matchedAt: new Date(Date.now() - 1 * 60 * 60 * 1000), // 1 time siden
    lastMessage: 'Match! Vi er veldig interessert i din bakgrunn.',
    lastMessageAt: new Date(Date.now() - 45 * 60 * 1000), // 45 min siden
    unreadCount: 1,
    isRevealed: false
  }
]

export interface Message {
  id: string
  matchId: string
  senderId: 'user' | 'employer'
  content: string
  sentAt: Date
  isRead: boolean
}

export const mockMessages: Record<string, Message[]> = {
  m1: [
    {
      id: 'msg1',
      matchId: 'm1',
      senderId: 'user',
      content: 'Hei! Takk for matchen. Stillingen virker veldig spennende!',
      sentAt: new Date(Date.now() - 2 * 60 * 60 * 1000),
      isRead: true
    },
    {
      id: 'msg2',
      matchId: 'm1',
      senderId: 'employer',
      content: 'Hei! Vi setter pris på din interesse. Når passer det for en uformell chat?',
      sentAt: new Date(Date.now() - 90 * 60 * 1000),
      isRead: true
    },
    {
      id: 'msg3',
      matchId: 'm1',
      senderId: 'employer',
      content: 'Vi kan møtes på Teams eller Google Meet, hva foretrekker du?',
      sentAt: new Date(Date.now() - 30 * 60 * 1000),
      isRead: false
    }
  ],
  m2: [
    {
      id: 'msg4',
      matchId: 'm2',
      senderId: 'employer',
      content: 'Hei! Hyggelig å matche med deg. Vi ser du har erfaring med cloud-teknologi.',
      sentAt: new Date(Date.now() - 24 * 60 * 60 * 1000),
      isRead: true
    },
    {
      id: 'msg5',
      matchId: 'm2',
      senderId: 'user',
      content: 'Hei! Ja, jeg har jobbet med Kubernetes i 3 år nå.',
      sentAt: new Date(Date.now() - 12 * 60 * 60 * 1000),
      isRead: true
    },
    {
      id: 'msg6',
      matchId: 'm2',
      senderId: 'employer',
      content: 'Flott! Kan du fortelle litt om din erfaring med Kubernetes?',
      sentAt: new Date(Date.now() - 3 * 60 * 60 * 1000),
      isRead: true
    }
  ],
  m3: [
    {
      id: 'msg7',
      matchId: 'm3',
      senderId: 'user',
      content: 'Hei! React Native er min favoritt-teknologi. Jobber dere med Expo?',
      sentAt: new Date(Date.now() - 48 * 60 * 60 * 1000),
      isRead: true
    },
    {
      id: 'msg8',
      matchId: 'm3',
      senderId: 'employer',
      content: 'Ja! Vi bruker Expo i de fleste prosjektene våre.',
      sentAt: new Date(Date.now() - 36 * 60 * 60 * 1000),
      isRead: true
    },
    {
      id: 'msg9',
      matchId: 'm3',
      senderId: 'user',
      content: 'Perfekt! Jeg har bygget flere apps med Expo og elsker det.',
      sentAt: new Date(Date.now() - 30 * 60 * 60 * 1000),
      isRead: true
    },
    {
      id: 'msg10',
      matchId: 'm3',
      senderId: 'employer',
      content: 'Takk for svar! Vi ser frem til å lære deg bedre å kjenne.',
      sentAt: new Date(Date.now() - 24 * 60 * 60 * 1000),
      isRead: false
    }
  ],
  m4: [
    {
      id: 'msg11',
      matchId: 'm4',
      senderId: 'employer',
      content: 'Hei! Velkommen til Startup Hub Oslo. Vi likte profilen din!',
      sentAt: new Date(Date.now() - 4 * 60 * 60 * 1000),
      isRead: true
    },
    {
      id: 'msg12',
      matchId: 'm4',
      senderId: 'user',
      content: 'Takk! Jeg er veldig interessert i startup-miljøet.',
      sentAt: new Date(Date.now() - 3 * 60 * 60 * 1000),
      isRead: true
    },
    {
      id: 'msg13',
      matchId: 'm4',
      senderId: 'employer',
      content: 'Vi liker profilen din! Har du erfaring med Next.js?',
      sentAt: new Date(Date.now() - 1 * 60 * 60 * 1000),
      isRead: false
    }
  ],
  m5: [
    {
      id: 'msg14',
      matchId: 'm5',
      senderId: 'employer',
      content: 'Hei! FinTech Norge her. Vi ser du har solid erfaring med Node.js.',
      sentAt: new Date(Date.now() - 6 * 60 * 60 * 1000),
      isRead: true
    },
    {
      id: 'msg15',
      matchId: 'm5',
      senderId: 'user',
      content: 'Hei! Ja, jeg har jobbet med Node.js i 5 år, inkludert finansielle systemer.',
      sentAt: new Date(Date.now() - 5 * 60 * 60 * 1000),
      isRead: true
    },
    {
      id: 'msg16',
      matchId: 'm5',
      senderId: 'employer',
      content: 'Imponerende! Vi bygger neste generasjons betalingsløsninger.',
      sentAt: new Date(Date.now() - 4 * 60 * 60 * 1000),
      isRead: true
    },
    {
      id: 'msg17',
      matchId: 'm5',
      senderId: 'employer',
      content: 'Har du erfaring med PCI-DSS compliance?',
      sentAt: new Date(Date.now() - 3 * 60 * 60 * 1000),
      isRead: false
    },
    {
      id: 'msg18',
      matchId: 'm5',
      senderId: 'employer',
      content: 'Vi har også et spennende prosjekt med kryptovaluta.',
      sentAt: new Date(Date.now() - 2.5 * 60 * 60 * 1000),
      isRead: false
    },
    {
      id: 'msg19',
      matchId: 'm5',
      senderId: 'employer',
      content: 'Hei! Vi ser du har solid erfaring med Node.js. Spennende!',
      sentAt: new Date(Date.now() - 2 * 60 * 60 * 1000),
      isRead: false
    }
  ],
  m6: [
    {
      id: 'msg20',
      matchId: 'm6',
      senderId: 'employer',
      content: 'Hei fra Design Studio Bergen! Vi elsket portfolioen din.',
      sentAt: new Date(Date.now() - 72 * 60 * 60 * 1000),
      isRead: true
    },
    {
      id: 'msg21',
      matchId: 'm6',
      senderId: 'user',
      content: 'Tusen takk! Jeg har alltid vært fascinert av skandinavisk design.',
      sentAt: new Date(Date.now() - 60 * 60 * 60 * 1000),
      isRead: true
    },
    {
      id: 'msg22',
      matchId: 'm6',
      senderId: 'employer',
      content: 'Vi jobber med noen av Norges største merkevarer. Interessert?',
      sentAt: new Date(Date.now() - 48 * 60 * 60 * 1000),
      isRead: true
    },
    {
      id: 'msg23',
      matchId: 'm6',
      senderId: 'user',
      content: 'Absolutt! Fortell meg mer om prosjektene deres.',
      sentAt: new Date(Date.now() - 36 * 60 * 60 * 1000),
      isRead: true
    },
    {
      id: 'msg24',
      matchId: 'm6',
      senderId: 'employer',
      content: 'Portfolioen din er imponerende! Kan vi ta en prat?',
      sentAt: new Date(Date.now() - 12 * 60 * 60 * 1000),
      isRead: true
    }
  ],
  m7: [
    {
      id: 'msg25',
      matchId: 'm7',
      senderId: 'employer',
      content: 'Hei! Vi søker en erfaren Tech Lead til vårt team.',
      sentAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000),
      isRead: true
    },
    {
      id: 'msg26',
      matchId: 'm7',
      senderId: 'user',
      content: 'Hei! Det høres interessant ut. Hva slags prosjekter jobber dere med?',
      sentAt: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000),
      isRead: true
    },
    {
      id: 'msg27',
      matchId: 'm7',
      senderId: 'employer',
      content: 'Vi bygger enterprise-løsninger for store norske selskaper. Kan vi ta et møte?',
      sentAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000),
      isRead: true
    },
    {
      id: 'msg28',
      matchId: 'm7',
      senderId: 'user',
      content: 'Ja, gjerne! Jeg er tilgjengelig neste uke.',
      sentAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000),
      isRead: true
    },
    {
      id: 'msg29',
      matchId: 'm7',
      senderId: 'employer',
      content: 'Perfekt! Vi hadde en fin samtale. Teamet var imponert.',
      sentAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000),
      isRead: true
    },
    {
      id: 'msg30',
      matchId: 'm7',
      senderId: 'employer',
      content: 'Takk for en fin samtale! Vi kommer tilbake med tilbud snart.',
      sentAt: new Date(Date.now() - 6 * 60 * 60 * 1000),
      isRead: false
    }
  ],
  m8: [
    {
      id: 'msg31',
      matchId: 'm8',
      senderId: 'employer',
      content: 'Match! 🎉 Vi er veldig interessert i din bakgrunn innen data engineering.',
      sentAt: new Date(Date.now() - 1 * 60 * 60 * 1000),
      isRead: true
    },
    {
      id: 'msg32',
      matchId: 'm8',
      senderId: 'employer',
      content: 'Vi jobber med cutting-edge AI og machine learning. Spennende prosjekter!',
      sentAt: new Date(Date.now() - 45 * 60 * 1000),
      isRead: false
    }
  ]
}
